function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable react/jsx-key */

/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { DropdownItem } from '../../../../molecules/Dropdown';
import Item from '../../../../molecules/Dropdown/Item';
import { filterData } from './helper';
export var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  function Dropdown(_props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).call(this, _props));

    _this.shouldComponentUpdate = function (nextProps) {
      if (nextProps.checkboxState != _this.props.checkboxState) return true;
      if (nextProps.dropdownState != _this.props.dropdownState) return true;
      return false;
    };

    _this.toggleShowList = function (id) {
      _this.props.toggleDropdown(_this.props.countryID, _this.props.plotID, id);
    };

    _this.toggleCheckbox = function (key) {
      filterData(_this.props, key);
    };

    _this.render = function () {
      var props = _this.props;
      var idx0 = props.data;
      var block = _this.props.block;

      if (idx0.length > 0) {
        return idx0.map(function (e) {
          var idx1 = e.idx1;

          if (idx1) {
            var show = props.dropdownState[e._id] ? props.dropdownState[e._id].show : false;
            return React.createElement("div", {
              key: e._id
            }, React.createElement(Item, {
              header: true,
              width: '70%',
              _id: e._id,
              tag: e.tag,
              key: e._id ? e._id : e._id,
              color: e.color ? e.color : '#606060',
              active: show,
              checkboxState: props.checkboxState,
              toggleShowList: function toggleShowList() {
                return _this.toggleShowList(e._id);
              },
              toggleCheckbox: _this.toggleCheckbox
            }), show ? idx1.map(function (o) {
              var show1 = props.dropdownState[o._id] ? props.dropdownState[o._id].show : false;
              var idx2 = o.idx2;

              if (idx2) {
                return React.createElement("div", {
                  key: o._id
                }, React.createElement(Item, {
                  toggleCheckbox: _this.toggleCheckbox,
                  checkboxState: props.checkboxState,
                  tab: true,
                  width: '65%',
                  left: '5%',
                  header: true,
                  _id: o._id,
                  tag: o.tag,
                  key: o._id ? o._id : o.tag,
                  color: o.color ? o.color : e.color ? e.color : '#606060',
                  active: show1,
                  toggleShowList: function toggleShowList() {
                    return _this.toggleShowList(o._id);
                  }
                }), show1 ? idx2.map(function (b) {
                  if (b.idx3) {
                    return React.createElement(DropdownItem, {
                      toggleCheckbox: _this.toggleCheckbox,
                      checkboxState: props.checkboxState,
                      dropdownState: props.dropdownState,
                      toggleShowList: function toggleShowList() {
                        return _this.toggleShowList(b._id);
                      },
                      _id: b._id,
                      tag: b.tag,
                      key: b._id ? b._id : b.tag,
                      color: b.color ? b.color : o.color ? o.color : e.color ? e.color : '#606060',
                      items: b.idx3,
                      active: false,
                      tab: true
                    });
                  }

                  return React.createElement(Item, {
                    toggleCheckbox: _this.toggleCheckbox,
                    checkboxState: props.checkboxState,
                    tab: true,
                    width: '60%',
                    left: '10%',
                    _id: b._id,
                    tag: b.tag,
                    key: b._id ? b._id : b.tag,
                    color: b.color ? b.color : o.color ? o.color : e.color ? e.color : '#606060',
                    active: show1
                  });
                }) : '');
              }

              return React.createElement(Item, {
                toggleCheckbox: _this.toggleCheckbox,
                checkboxState: props.checkboxState,
                _id: o._id,
                tag: o.tag,
                key: o._id ? o._id : o.tag,
                color: o.color ? o.color : e.color ? e.color : '#606060',
                active: false,
                left: '15px'
              });
            }) : '');
          }

          return React.createElement(Item, {
            block: block,
            toggleCheckbox: _this.toggleCheckbox,
            checkboxState: props.checkboxState,
            _id: e._id,
            tag: e.tag,
            key: e._id ? e._id : e.tag,
            color: e.color ? e.color : '#606060',
            active: false
          });
        });
      }
    };

    _this.state = {};
    return _this;
  }

  return Dropdown;
}(React.Component);
Dropdown.propTypes = {
  countryID: PropTypes.string.isRequired,
  plotID: PropTypes.string.isRequired,
  block: PropTypes.bool.isRequired,
  dropdownState: PropTypes.object.isRequired,
  checkboxState: PropTypes.object.isRequired,
  toggleCheckbox: PropTypes.func.isRequired,
  toggleDropdown: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired
};
export default Dropdown;